module.exports = __webpack_public_path__ + "static/media/picture-(146).23bfc30d.JPG";